import { render, staticRenderFns } from "./CmgPointsHistoryCell.vue?vue&type=template&id=420ebcba&scoped=true&lang=pug&"
import script from "./cmg-points-history-cell.ts?vue&type=script&lang=ts&"
export * from "./cmg-points-history-cell.ts?vue&type=script&lang=ts&"
import style0 from "./CmgPointsHistoryCell.vue?vue&type=style&index=0&id=420ebcba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "420ebcba",
  null
  
)

export default component.exports